const Dropdown = $.fn.select2.amd.require('select2/dropdown');

Dropdown.prototype.render = function renderDropdown() {
  const $dropdown = $('<span class="select2-dropdown">' +
      '<span class="select2-dropdown__back"></span>' +
      '<span class="select2-results"></span>' +
    '</span>');

  $dropdown.attr('dir', this.options.get('dir'));

  const $that = this;
  $dropdown.find('.select2-dropdown__back').add($dropdown).on('click', function close(event) {
    if (event.target !== this) {
      return false;
    }
    $that.$element.select2('close');
    return true;
  });

  this.$dropdown = $dropdown;

  return $dropdown;
};


$.fn.select2.amd.define('select2/i18n/pt-BR', [], () =>
  // English
  ({
    errorLoading() {
      return 'Os resultados não puderam ser carregados.';
    },
    inputTooLong(args) {
      const overChars = args.input.length - args.maximum;

      let message = `Apague ${overChars} letra`;

      if (overChars !== 1) {
        message += 's';
      }

      return message;
    },
    inputTooShort(args) {
      const remainingChars = args.minimum - args.input.length;

      const message = `Digite ${remainingChars} ou mais letras`;

      return message;
    },
    loadingMore() {
      return 'Carregando mais resultados…';
    },
    maximumSelected(args) {
      let message = `Você só pode selecionar ${args.maximum} ite`;

      if (args.maximum === 1) {
        message += 'm';
      } else {
        message += 'ns';
      }

      return message;
    },
    noResults() {
      return 'Nenhum resultado encontrado';
    },
    searching() {
      return 'Buscando…';
    },
  }));

$.fn.select2.defaults.set('language', 'pt-BR');
